<div class="flex flex-col w-full gap-4 p-6">

  <div class="flex flex-row items-center justify-between w-full">
  <h6 class="flex-1 m-0 text-2xl">Please enter your comment up to 1,000 characters</h6>
    <button id="sd-non-eligible-comment-close-icon" (click)="cancel()">
      <span class="text-2xl material-symbols-rounded text-subtle">close</span>
    </button>
  </div>
  <div class="my-4 border-b border-gray-200"></div>

  <form [formGroup]="userCommentForm">
    <div class="flex flex-col children:w-full">
      <app-text-area id="courtesy-comment" title="Comment" formControlName="userComment" [rows]="6"></app-text-area>
    </div>
  </form>

  <div class="my-2 border-b border-gray-200"></div>

  <div class="flex justify-end gap-6 mr-4">
    <button class="px-8 py-3 border border-black btn btn-neutral" (click)="cancel()">Cancel</button>
    <button class="px-8 py-3 btn btn-primary" (click)="onSubmit()" [disabled]="userCommentForm.get('userComment')?.invalid">Submit</button>
  </div>

</div>
